import { render, staticRenderFns } from "./ParticipantMenue.vue?vue&type=template&id=d5816830&scoped=true&"
import script from "./ParticipantMenue.vue?vue&type=script&lang=js&"
export * from "./ParticipantMenue.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantMenue.vue?vue&type=style&index=0&id=d5816830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5816830",
  null
  
)

export default component.exports